import { forwardRef, useState } from "react";
import { useDispatch } from "react-redux";
import moengage from "@moengage/web-sdk";
import LogoutIcon from "@mui/icons-material/Logout";
import { Button } from "@mui/material";
import useMoEngage from "hooks/useMoEngage";
import useTracker from "hooks/useTracker";
import { translate } from "locale/formatter";
import { actions } from "slices/app.slice";
import { theme } from "styles/AtomicStyles";
import { HOME_SCREEN_EVENTS } from "utils/events";
import { removeUser } from "utils/localStorage";

import ConfirmationDialog from "components/Dialog/ConfirmationDialog";
import Text from "components/Text";

const LogoutButton = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const trackUser = useTracker();
  const dispatch = useDispatch();
  const tracker = useMoEngage();

  const handleLogout = async () => {
    const logoutSuccess = dispatch(actions.logout());
    removeUser();
    tracker(HOME_SCREEN_EVENTS.LOGOUT_CLICK, {
      LogoutStatus: logoutSuccess ? "Success" : "Failure",
    });
    setOpen(false);
  };

  const handleClickOpen = () => {
    trackUser("l_click_logout");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        ref={ref}
        onClick={handleClickOpen}
        data-cy="home.logOutButton"
        className="bg-white rounded-xl !p-0"
      >
        <Text className="flex gap-3 items-center text-xl">
          <LogoutIcon
            sx={{ color: theme.colors.tealColor, width: 24, height: 24 }}
          />
          {translate("logout")}
        </Text>
      </Button>

      <ConfirmationDialog
        open={open}
        onCloseHandler={handleClose}
        secondaryBtnHandler={handleClose}
        primaryBtnHandler={() => {
          handleLogout();
          moengage.destroy_session();
        }}
        header={
          <div
            className="text-center"
            style={{
              fontSize: "1.5rem",
              fontWeight: "bold",
              color: theme.colors.tealColor,
            }}
          >
            {translate("logout")}
          </div>
        }
        content={
          <div>
            <div
              className="text-[#333]"
              style={{
                fontSize: "1.3rem",
                fontWeight: 400,
                lineHeight: 1.6,
                paddingTop: "0.5rem",
                paddingLeft: "1rem",
                paddingRight: "1rem",
                paddingBottom: "0.5rem",

                textAlign: "center",
              }}
            >
              {translate("are_you_sure_you_want_to_logout")}
            </div>
            <div
              className="flex justify-center px-6 pt-6 gap-4"
              style={{
                gap: "16px",
              }}
            >
              <Button
                onClick={handleClose}
                variant="outlined"
                fullWidth
                sx={{
                  textTransform: "none",
                  borderRadius: "10px",
                  borderColor: theme.colors.tealColor,
                  color: theme.colors.tealColor,
                  fontWeight: 500,
                  fontSize: "1.22rem",
                  "&:hover": {
                    backgroundColor: "transparent",
                    borderColor: theme.colors.tealColor,
                  },
                }}
              >
                {translate("cancel")}
              </Button>
              <Button
                onClick={() => {
                  handleLogout();
                  moengage.destroy_session();
                }}
                variant="contained"
                fullWidth
                autoFocus
                sx={{
                  textTransform: "none",
                  borderRadius: "10px",
                  backgroundColor: theme.colors.tealColor,
                  color: "#fff",
                  fontWeight: 500,
                  fontSize: "1.22rem",
                  "&:hover": {
                    backgroundColor: "#1e5b56",
                  },
                }}
              >
                {translate("confirm")}
              </Button>
            </div>
          </div>
        }
        secondaryBtnText={" "}
        primaryBtntext={null}
      />
    </>
  );
});

export default LogoutButton;
